import { render, staticRenderFns } from "./AttachToDocumentTemplate.vue?vue&type=template&id=157e829d&lang=pug"
import script from "./AttachToDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./AttachToDocumentTemplate.vue?vue&type=script&lang=js"
import style0 from "./AttachToDocumentTemplate.vue?vue&type=style&index=0&id=157e829d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports